import {animate, keyframes, style, transition} from "@angular/animations";

const duration: number = 200; // Slightly longer for smoother animation

export const fadeIn = [
  style({ opacity: 0 }),
  animate(duration, style({ opacity: 1 }))
];

export const fadeOut = [
  style({ opacity: 1 }),
  animate(duration, style({ opacity: 0 }))
];

// Keep the original transition format but add proper fade support
export const fade = [
  transition('void => *', fadeIn),
  transition('* => void', fadeOut)
];

export const scaleIn = [
  style({ transform: 'scale(0.9)', opacity: 0 }),
  animate(duration, style({ transform: 'scale(1)', opacity: 1 }))
];

export const scaleOut = [
  style({ transform: 'scale(1)', opacity: 1 }),
  animate(duration, style({ transform: 'scale(0.9)', opacity: 0 }))
];

export const scale = [
  transition('void => *', scaleIn),
  transition('* => void', scaleOut)
];

export const shake = [
  animate(duration, keyframes([
        style({transform: 'scale(1)'}),
        style({transform: 'scale(1.02)'}),
        style({transform: 'scale(1)'})
      ])
  )];
